export default __webpack_public_path__ + "static/media/logo-ford-mid_south-white.ed4e520b.png";